import { render, staticRenderFns } from "./TalkSortCount.vue?vue&type=template&id=424602b4&scoped=true&"
import script from "./TalkSortCount.vue?vue&type=script&lang=js&"
export * from "./TalkSortCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424602b4",
  null
  
)

export default component.exports